/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import * as palette from '../../config/colors';

const c = (theme, key, fallback) => theme?.colors?.[key] ?? fallback;

export const RequiredMark = styled.span`
   color: ${palette.errorColor};
   font-weight: 800;
   margin-left: 4px;
`;

export const Field = styled.div`
   display: flex;
   flex-direction: column;
   gap: 6px;
   min-width: 0;

   label {
      font-size: 0.75rem;
      font-weight: 700;
      color: ${({ theme }) => c(theme, 'textMuted', '#666')};
   }

   ${({ $col }) => ($col ? `grid-column: span ${$col};` : '')}

   @media (max-width: 900px) {
      ${({ $colMobile, $col }) =>
         $colMobile
            ? `grid-column: span ${$colMobile};`
            : $col
              ? `grid-column: span ${$col};`
              : ''}
   }

   + ${({ $alignEnd }) => ($alignEnd ? 'align-self: end;' : '')} input:not([type='checkbox']),
   select,
   textarea,
   & input:not([type='checkbox']),
   & select,
   & textarea {
      font-size: 0.75rem;
      max-width: 100%;
      min-width: 0;
      box-sizing: border-box;
      width: 100%;
      min-height: 40px;
      padding: 9px 10px;
      border-radius: 10px;
      border: 1px solid
         ${({ theme }) => c(theme, 'border', palette.lightBgText)};
      background: ${({ theme }) => c(theme, 'surface', '#fff')};
      color: ${({ theme }) => c(theme, 'text', '#111')};
      outline: none;
   }

   & input[type='checkbox'] {
      height: 16px;
      width: 16px;
      min-height: 0;
   }

   textarea {
      min-height: 96px;
      resize: vertical;
   }

   input:not([type='checkbox']):focus,
   select:focus,
   textarea:focus {
      border-color: ${({ theme }) => c(theme, 'primary', palette.primaryColor)};
      box-shadow: 0 0 0 3px rgba(64, 152, 239, 0.18);
   }

   input:disabled {
      opacity: 0.75;
      cursor: not-allowed;
      background-color: #dbdbdb;
   }
`;
